import { useState } from 'react';
import { Ban } from 'lucide-react';
import { CxDialog } from '@/cajita/overlay';

export interface VoidDialogProps {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  fullNumber: string;
  onConfirm: (reason: string) => void;
  isSubmitting?: boolean;
}

export function VoidDialog({ open, onOpenChange, fullNumber, onConfirm, isSubmitting }: VoidDialogProps): JSX.Element | null {
  const [reason, setReason] = useState('');

  if (!open) return null;

  return (
    <CxDialog
      title={`Anular ${fullNumber}`}
      sub="El comprobante se incluirá en el resumen diario de baja (RA) que se envía a SUNAT. No se puede deshacer."
      icon={<Ban size={20} />}
      iconTone="error"
      onClose={() => onOpenChange(false)}
      footer={
        <>
          <button className="btn btn-secondary grow" onClick={() => onOpenChange(false)} disabled={isSubmitting}>
            Cancelar
          </button>
          <button className="btn btn-danger grow" onClick={() => onConfirm(reason)} disabled={reason.trim().length < 3 || isSubmitting}>
            {isSubmitting ? 'Anulando…' : 'Anular'}
          </button>
        </>
      }
    >
      <div className="field">
        <label className="label">Motivo</label>
        <textarea
          className="input"
          value={reason}
          rows={3}
          maxLength={200}
          placeholder="Ej. Error en el monto del comprobante"
          onChange={(e) => setReason(e.target.value)}
        />
      </div>
    </CxDialog>
  );
}
